import { alpha } from '@mui/material/styles';

// ─── Brand: rich violet #7C3AED — distinctive, professional, not harsh ────────
function createGradient(color1, color2) {
  return `linear-gradient(135deg, ${color1}, ${color2})`;
}

const GREY = {
  0:   '#FFFFFF',
  50:  '#F8FAFC',
  100: '#F1F5F9',   // page background — very light slate
  200: '#E2E8F0',
  300: '#CBD5E1',
  400: '#94A3B8',
  500: '#64748B',
  600: '#475569',
  700: '#334155',
  800: '#1E293B',
  900: '#0F172A',
  500_8:  alpha('#64748B', 0.08),
  500_12: alpha('#64748B', 0.12),
  500_16: alpha('#64748B', 0.16),
  500_24: alpha('#64748B', 0.24),
  500_32: alpha('#64748B', 0.32),
  500_48: alpha('#64748B', 0.48),
  500_56: alpha('#64748B', 0.56),
  500_80: alpha('#64748B', 0.80),
};

// Violet — rich, deep, professional
const PRIMARY = {
  lighter:  '#EDE9FE',
  light:    '#C4B5FD',
  main:     '#7C3AED',
  dark:     '#5B21B6',
  darker:   '#3B0764',
  contrastText: '#FFFFFF',
};

// Emerald secondary
const SECONDARY = {
  lighter:  '#ECFDF5',
  light:    '#6EE7B7',
  main:     '#10B981',
  dark:     '#047857',
  darker:   '#064E3B',
  contrastText: '#FFFFFF',
};

const INFO = {
  lighter: '#E0F2FE',
  light:   '#7DD3FC',
  main:    '#0EA5E9',
  dark:    '#0369A1',
  darker:  '#0C4A6E',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#ECFDF5',
  light:   '#6EE7B7',
  main:    '#10B981',
  dark:    '#047857',
  darker:  '#064E3B',
  contrastText: '#fff',
};

const WARNING = {
  lighter: '#FFFBEB',
  light:   '#FDE68A',
  main:    '#F59E0B',
  dark:    '#B45309',
  darker:  '#78350F',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FEF2F2',
  light:   '#FCA5A5',
  main:    '#EF4444',
  dark:    '#B91C1C',
  darker:  '#7F1D1D',
  contrastText: '#fff',
};

const GRADIENTS = {
  primary:   createGradient('#A78BFA', '#7C3AED'),
  secondary: createGradient('#6EE7B7', '#10B981'),
  info:      createGradient('#7DD3FC', '#0EA5E9'),
  success:   createGradient('#6EE7B7', '#10B981'),
  warning:   createGradient('#FDE68A', '#F59E0B'),
  error:     createGradient('#FCA5A5', '#EF4444'),
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary:   { ...PRIMARY },
  secondary: { ...SECONDARY },
  info:      { ...INFO },
  success:   { ...SUCCESS },
  warning:   { ...WARNING },
  error:     { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  divider: GREY[500_24],
  text: {
    primary:   GREY[900],
    secondary: GREY[600],
    disabled:  GREY[400],
  },
  background: {
    paper:   '#FFFFFF',
    default: '#F8FAFC',    // very light — cards pop cleanly
    neutral: GREY[200],
  },
  action: {
    active:             GREY[600],
    hover:              GREY[500_8],
    selected:           alpha(PRIMARY.main, 0.08),
    disabled:           GREY[500_80],
    disabledBackground: GREY[500_24],
    focus:              GREY[500_24],
    hoverOpacity:       0.08,
    disabledOpacity:    0.48,
  },
};

export default palette;
